// extracted by mini-css-extract-plugin
export default {"notFoundWrapper":"notFoundWrapper--oPz0z","container":"container--lTaOu","image":"image--E27Ve","headline":"headline--INRv4","button":"button--u60cL","rotation":"rotation--MHNl4"};